import Breadcrumbs from "@/components/Breadcrumbs";

// Navy page hero used across sub-pages. Optional background image.
export default function PageHero({ eyebrow, title, highlight, subtitle, image, crumbs, children }) {
  return (
    <section className="relative overflow-hidden bg-navy">
      {image && <img src={image} alt="" aria-hidden="true" style={{ opacity: 0.3 }} className="absolute inset-0 h-full w-full object-cover" />}
      <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(11,25,44,0.97) 0%, rgba(11,25,44,0.90) 55%, rgba(11,25,44,0.82) 100%)" }} />
      <div className="container-x relative py-14 sm:py-16">
        {crumbs && <div className="mb-5"><Breadcrumbs items={crumbs} /></div>}
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h1 className="mt-3 max-w-3xl font-serif text-4xl font-bold leading-[1.1] text-white sm:text-5xl">
          {title} {highlight && <span className="text-gold">{highlight}</span>}
        </h1>
        {subtitle && <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-200">{subtitle}</p>}
        {children && <div className="mt-7">{children}</div>}
      </div>
    </section>
  );
}
